export const API_CONFIG = {
  faq: {
    list: store => `rest/${store}/V1/amadeus/public/faq`
  },
  contact: {
    configs: store => `rest/${store}/V1/amadeus/public/modularity/config`,
    sendEmail: store => `rest/${store}/V1/amadeus/private/contact_us/send`
  },
  news: {
    posts: store => `rest/${store}/V1/amadeus/public/news/posts`,
    post: (store, url, id) => `rest/${store}/V1/amadeus/public/news/post/${url}/segment_rule/${id}`
  },
  content: {
    page: (page, store) => `rest/${store}/V1/amadeus/public/cms_page/${page}`
  },
  registration: {
    profiles: () => `rest/all/V1/amadeus/private/registration`,
    eloqua: () => `https://s266319173.t.eloqua.com/e/f2`,
    configs: store => `rest/${store}/V1/amadeus/public/modularity/config`,
    menu: store => `rest/${store}/V1/amadeus/public/menu/list`,
    agreement: store => `rest/${store}/V1/amadeus/public/cms_page/registration-agreement`
  },
  agreement: {
    menu: store => `rest/${store}/V1/amadeus/public/menu/list`,
    configs: store => `rest/${store}/V1/amadeus/public/modularity/config`,
    agreement: store => `rest/${store}/V1/amadeus/public/cms_page/registration-agreement`,
    terms: () => `rest/all/V1/amadeus/private/customer/terms_and_conditions`
  },
  sso: {
    productionASH: () => `https://servicehub.amadeus.com/`,
    integrationASH: () => `https://integration.servicehub.amadeus.com/`,
    productionASHSupport: () => `https://servicehub.amadeus.com/c/portal/view-solution/`,
    integrationASHSupport: () => `https://integration.servicehub.amadeus.com/c/portal/view-solution/`,
    ASHSupportPageForPlusMe: () => `amadeus-direct-and-amadeus-me-entry-point`,
    trainingItaly: () => `https://servicehub.it.amadeus.com/login.aspx`,
    liveTravel: () => `https://live-travel.community.amadeus.com/?_58_redirect=/web/community`,
    ssoEncrypted: () => `api/amadeus/encryptedSSOParams`,
    ssoLoyalty: () => `api/amadeus/loyalty/link/`,
    loginServiceBaseUrl: () =>
      `LoginService/authorize?service=ASH&response_type=id_token+token&prompt=none&redirect_uri=`,
    loginSECOBaseUrl: () => `LoginService/authorize?service=SECO_SSO&prompt=none&nonce=jhsd&response_mode=query&redirect_uri=`,
    pdtSECOSingleSignOn: () =>
    `https%3A%2F%2Facceptance.sellingplatformconnect.amadeus.com%2Flogin%2FloginFromSAMLSSO` +
    `%3FSITE%3DLOGINURL%26LANGUAGE%3DGB%26nonce%3Djhsd%26OV_SITE_SMART_PORTAL_URL`,
    prdSECOSingleSignOn: () =>
    `https%3A%2F%2Fwww.sellingplatformconnect.amadeus.com%2Flogin%2FloginFromSAMLSSO%3F` +
    `SITE%3DLOGINURL%26LANGUAGE%3DGB%26nonce%3Djhsd`
  },
  account: {
    wishlist: {
      items: agencyCAN => `api/amadeus/accountHierarchy/getWishlists?can=${agencyCAN}`,
      item: (agencyCAN, id) => `api/amadeus/accountHierarchy/getWishlistDetails?can=${agencyCAN}&id=${id}`,
      configs: store => `rest/${store}/V1/amadeus/public/modularity/config`,
      convert: (store, id) => `rest/${store}/V1/amadeus/private/wishlist/tocart/${id}`
    }
  },
  banner: (store, role, segment) => `rest/${store}/V1/amadeus/public/banners?role=${role}&segment=${segment}`
};
